





























































import VueFramework from 'vue'
import BaseModal from  '../../components/modal/basemodal.vue';
import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import VeeValidate from 'vee-validate';
import {Channel, CreateChannel} from "../../repository/messagehub.dtos";
import ChannelApi from "../../repository/ChannelApi";
import * as channelRecord from "../../store/Channel/ChannelRecord";
VueFramework.use(VeeValidate);
@Component({
    components: {
        BaseModal

    },
    name: 'CreateChannelModal',
})
export default class CreateChannelModal extends Vue{
    @Prop({ default: false })show!:boolean
    @Prop({ default: "600px" }) containerWidth!: string
    channelName: string = ''
    channelDescription: string = ''
    isPrivate: boolean = false
    channelApi: ChannelApi = new ChannelApi()
    dictionary = {
        custom: {
            channelName: {
                required: () => 'Channel name cannot be empty',

            },
            channelDescription: {
                required: () => 'Channel description cannot be empty',

            }
        }
    }

    mounted () {

        this.$validator.localize('en', this.dictionary)
    }
    closeModal(){

        this.$emit('cancelModal')
    }
    async createChannelCommand(){
        let result = await this.$validator.validateAll()
        if (result){
            let data = new CreateChannel(this.channelName, this.channelDescription, !this.isPrivate)
            this.$validator.reset()
            this.channelName = ''
            this.channelDescription = ''
            try {

                let resultofCall = await this.channelApi.createChannel(data)
                if (resultofCall.status === 200){
                    channelRecord.addChannel(this.$store, <Channel> resultofCall.data.data)
                    this.$emit('channelCreated')
                }
            }
            catch (e) {
                console.log(e)
            }

        }
    }

}
